import { createFileRoute } from '@tanstack/react-router';

import { TranslationSearchClaimable } from '@/module/Author/Translation/TranslationSearchClaimable';

export const Route = createFileRoute('/_auth/author/_author/translation/_translation/search-claimable')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <TranslationSearchClaimable />;
}
